import React, { useState, useEffect } from 'react';
import axiosInstance from '../../axiosConfig';
import CreatePost from './CreatePost';
import ForumPost_Display from "./ForumPost_Display";
import './Master.css'; // Updated import

const GeneralForum = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axiosInstance.get('/messageboard/forums/general/');
      console.log('Forum posts response:', response.data);
      setPosts(response.data || []);
    } catch (error) {
      console.error('Error fetching general forum posts:', error);
      setError('Failed to load forum posts. Please try again.');
      setPosts([]);
    } finally {
      setLoading(false);
    }
  };

  const handlePostCreated = (newPost) => {
    console.log('New post created:', newPost);
    setPosts((prevPosts) => [newPost, ...prevPosts]);
  };

  if (loading) {
    return <div className="loading">Loading forum posts...</div>;
  }

  if (error) {
    return (
      <div className="error">
        <p>{error}</p>
        <button onClick={fetchPosts}>Try Again</button>
      </div>
    );
  }

  return (
    <>
      {/* Create Post Button - OUTSIDE of any container */}
      <CreatePost
        apiEndpoint="/messageboard/forums/general/"
        onPostCreated={handlePostCreated}
      />

      {/* Posts List Container */}
      <div className="general-forum-container">
        {posts.length === 0 ? (
          <div className="no-posts">
            <p>No posts yet. Be the first to create one!</p>
          </div>
        ) : (
          <div className="posts-container">
            {posts.map((post) => (
              <ForumPost_Display
                key={post.id}
                post={post}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default GeneralForum;